module.exports = __webpack_public_path__ + "static/manufacturing-28cbd5a2789dc2e57789f1966b469e19.jpg";